import { render, staticRenderFns } from "./WheelOfFortuneSettings.vue?vue&type=template&id=4640b6d1&"
import script from "./WheelOfFortuneSettings.vue?vue&type=script&lang=js&"
export * from "./WheelOfFortuneSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports